/**
 * Tiny registration shim for UI → SW dispatch from non-React modules.
 *
 * `BackgroundServiceProvider` owns the PortMessenger that talks to the SW.
 * Modules outside the React tree (e.g. `railgunOffscreenClient` recovery)
 * need a way to dispatch controller actions without taking a React dep.
 * The provider calls `setUiBackgroundDispatch` once on init; consumers
 * call `getUiBackgroundDispatch` and bail gracefully if unavailable
 * (e.g. SW context, or before the provider has mounted).
 */
import { Action } from '../actions'

type Dispatch = (action: Action) => void

let registered: Dispatch | null = null

export function setUiBackgroundDispatch(dispatch: Dispatch): void {
  registered = dispatch
}

export function getUiBackgroundDispatch(): Dispatch | null {
  return registered
}
